import CompetitionPage from '../pages/CompetitionPage.vue'
import GamePage from '../pages/GamePage.vue'
import MainPage from '../pages/MainPage.vue'
import TestPage from '../pages/TestPage.vue'

export const routes = [
  { path: '/competition/:competitionId', component: CompetitionPage },
  { path: '/:code', component: GamePage },
  { path: '/', component: MainPage },
  { path: '/test', component: TestPage },
]
